module.exports = __webpack_public_path__ + "img/logo_new_v3.5673c280.png";